import * as React from "react";
import { FormField } from "./FormField.jsx";
import * as btn from "./Button.module.scss";
import * as cls from "./FileBox.module.scss";
export { FileBox };
/**
 * Поле выбора файла.
 *
 * @param {Object} props - Атрибуты элемента.
 * @param {React.RefObject} [props.inputRef] - Ссылка на элемент `input`.
 * @param {string} [props.id] - Идентификатор поля.
 * Задаёт атрибуты `name` и `id`.
 * @param {string} [props.label] - Название и описание поля.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @param {boolean} [props.required] - Обязательное для заполнения.
 * @param {boolean} [props.disabled] - Неактивно.
 * @param {boolean} [props.autoComplete] - Разрешено ли автозаполнение.
 * @param {string} [props.checked] - Файл выбран.
 * @param {EventListener} [props.onChange] - Событие при изменении.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function FileBox({ inputRef, id, label, className, required, disabled, autoComplete, checked, onChange }) {
  return (
    <FormField label={label} labelFor={id} required={required} className={className} style="display: flex; flex-direction: row;">
      <label htmlFor={id} className={cls.btn_file_label}>
        <div className={btn.btn_default + " " + cls.btn_file}>{checked ? "✔ Загружено" : "Загрузить"}</div>
      </label>
      <input
        type="file"
        ref={inputRef}
        id={id}
        name={id}
        required={required && !checked}
        disabled={disabled}
        autoComplete={autoComplete}
        onChange={onChangeInput}
        className={cls.input_file}
        accept={"." + FileBox.accept.join(", .")}
        tabIndex="-1"
      />
    </FormField>
  );
  function onChangeInput(event) {
    const accept = new RegExp("\\.(" + FileBox.accept.join("|") + ")$");
    for (const file of event.target.files) {
      if (!accept.test(file.name.toLowerCase())) {
        event.target.value = "";
        console.debug("files:", event.target.files);
        alert("Недопустимый формат файла: " + file.name + "\nРазрешены только файлы: *." + FileBox.accept.join(", *."));
      }
    }
    onChange(event);
  }
}
/** Список поддерживаемых расширений файлов. */
FileBox.accept = ["bmp", "doc", "docx", "mp3", "ods", "odt", "ogg", "pdf", "png", "rtf", "txt", "wav", "xls", "xlsx"];
